<template>
    <div>
        <tab name="1"></tab>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.value" class="input-with-select" size="small">
                        <el-select v-model="params.type" slot="prepend" placeholder="请选择">
                            <el-option label="启动图ID" :value="1"></el-option>
                            <el-option label="启动图名称" :value="2"></el-option>
                            <el-option label="展示城市" :value="3"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="16" :lg="11" :xl="8">
                    <div class="clearfix timeType">
                        <el-input class="input-with-select fl" size="small">
                            <el-select v-model="params.dateType" slot="prepend" placeholder="请选择">
                                <el-option label="展示时间" :value="1"></el-option>
                                <el-option label="展示起始时间" :value="2"></el-option>
                            </el-select>
                        </el-input>
                        <el-date-picker
                            v-model="params.datetimerange"
                            type="datetimerange"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']"
                            unlink-panels
                            class="fl"
                            size="small">
                        </el-date-picker>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.showType" placeholder="请选择" size="small">
                        <el-option label="仅看显示的" :value="2"></el-option>
                        <el-option label="仅看隐藏的" :value="3"></el-option>
                        <el-option label="不限制状态" :value="1"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button
                v-if="$utils.have('/diagram/save')"
                type="primary"
                icon="el-icon-plus"
                @click="$router.push({path: `/operation/startupDiagram/add`})"
                size="small"
                >新建启动图</el-button
            >
        </div>
        <div class="page-list-box">
            <el-table
                :data="tableData"
                border
                style="width: 100%"
                v-loading="fetchLoading"
                size="small"
                stripe
            >
                <el-table-column prop="id" label="ID"></el-table-column>
                <el-table-column label="状态">
                    <template slot-scope="scope">
                        <p v-if="scope.row.isShow === 1">展示</p>
                        <p v-else-if="scope.row.isShow === 2">隐藏</p>
                    </template>
                </el-table-column>
                <el-table-column label="名称" min-width="120" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-link :href="scope.row.url" target="_blank" type="primary">{{ scope.row.title }}</el-link>
                    </template>
                </el-table-column>
                <el-table-column label="展示城市">
                    <template slot-scope="scope">
                        <p v-if="scope.row.cityCode === 0">全国</p>
                        <p v-else>{{ scope.row.cityName }}</p>
                    </template>
                </el-table-column>
				<el-table-column label="订单转化">
				    <template slot-scope="scope">
				       <p>下单人数：<span v-if="scope.row.orderUserCount">{{ scope.row.orderUserCount }}</span></p>
				       <p>转化率：<span v-if="scope.row.orderCr">{{ scope.row.orderCr }}%</span></p>
				    </template>
				</el-table-column>
				<el-table-column label="订单">
				    <template slot-scope="scope">
				       <p>订单数：<span v-if="scope.row.orderCount">{{ scope.row.orderCount }}</span></p>
				       <p>销售额：<span v-if="scope.row.saleAmountView">{{ scope.row.saleAmountView }}</span></p>
				    </template>
				</el-table-column>
                <el-table-column label="展示权重">
                    <template slot-scope="scope">
                        <p v-if="scope.row.rate === 5">较低</p>
                        <p v-else-if="scope.row.rate === 20">普通</p>
                        <p v-else-if="scope.row.rate === 100">较高</p>
                    </template>
                </el-table-column>
                <el-table-column width="175" label="展示时间段1">
                    <template slot-scope="scope">
                       <p v-if="scope.row.firstStartDate">起：{{ scope.row.firstStartDate }}</p>
                       <p v-if="scope.row.firstEndDate">止：{{ scope.row.firstEndDate }}</p>
                    </template>
                </el-table-column>
				<el-table-column width="175" label="展示时间段2">
				    <template slot-scope="scope">				     
						<p v-if="scope.row.secondStartDate">起：{{ scope.row.secondStartDate }}</p>
						<p v-if="scope.row.secondEndDate">止：{{ scope.row.secondEndDate }}</p>
				    </template>
				</el-table-column>
				<el-table-column width="175" label="展示时间段3">
				    <template slot-scope="scope">
				       <p v-if="scope.row.startDate">起：{{ scope.row.startDate }}</p>
				       <p v-if="scope.row.autoDeleteTime">止：{{ scope.row.autoDeleteTime }}</p>
				    </template>
				</el-table-column>
                <el-table-column prop="appClickNum" label="点击量"></el-table-column>
                <el-table-column fixed="right" width="80" label="操作" >
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            icon="el-icon-edit"
                            @click="edit(scope.row.id)"
                            >管理</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="tableData.length > 0" class="page-pagination-box">
            <el-pagination
                background
                @size-change="search"
                @current-change="fetch"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="totalCount || 0">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import Tab from './components/tab'
const defaultQuery = {
    pageNo: 1,
    pageSize: 15,
    endDate: '',
    startDate: '',
    dateType: 1,
    type: 1,
    value: '',
    showType: 1,
    datetimerange: []
};
export default {
    components: {
        Tab
    },
    data() {
        return {
            params: {...defaultQuery},
            fetchLoading: false,
            tableData: [],
            totalCount: 0,
        };
    },
    mounted(){
        this.fetch();
    },
    methods: {
        async fetch() {
            this.fetchLoading = true;
            const response = await this.$request({
                url: "/diagram/pageList",
                method: "POST",
                data: {
                    ...this.params,
                    startDate: this.params.datetimerange && this.params.datetimerange[0] || null,
                    endDate: this.params.datetimerange && this.params.datetimerange[1] || null
                },
            })
            const {state, msg, result} = response.data;
            this.fetchLoading = false;
            if (state != 1) return this.$message.error(msg);
            this.tableData = result.result;
            this.totalCount = result.totalCount;
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.fetch();
        },
        //重置搜索
        reset() {
            this.params = {...defaultQuery};
            this.search();
        },
        edit(id){
            this.$router.push({
                path:`/operation/startupDiagram/detail/${id}`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                },
            });
        }
    },
};
</script>
